import React from 'react';
import Currency from '../common/intl/Currency';
import { AccordionHeader } from 'core/controls';

const MathBoxAccordionHeader = ({ header, total }) => {
  return (
    <AccordionHeader expandIcon="chevron-down" collapseIcon="chevron-up">
      <div className="math-box-accordion-title">
        <div className="math-box-accordion-title__header">{header}</div>
        <div className="math-box-accordion-title__price">
          {typeof total === 'number' ? <Currency value={total} /> : total}
        </div>
      </div>
    </AccordionHeader>
  );
};

export default MathBoxAccordionHeader;
